import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";


const PrivateRoute = ({
  component: Component,
  auth: { isAuthenticated, loading },

  ...rest
}) => (
  
  <Route
    {...rest}
    render={(props) =>
      
      isAuthenticated === true && loading === false ? (
        
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
};

const mapSateToProps = (state) => ({
  auth: state.auth,
  subscription: state.subscription,
});
export default connect(mapSateToProps)(PrivateRoute);
